/* eslint-disable */
import { defineStore } from 'pinia';
import 'moment/dist/locale/el';
import 'moment/dist/locale/de';
import 'moment/dist/locale/fa';
import 'moment/dist/locale/fr';
import 'moment/dist/locale/sr';
import 'moment/dist/locale/tr';
import 'moment/dist/locale/es';
import 'moment/dist/locale/pt';
import 'moment/dist/locale/it';
import 'moment/dist/locale/ru';
import 'moment/dist/locale/ar';
import 'moment/dist/locale/he';
import { enUS, el, de, faIR, fr, sr, tr, es, pt, it, ru, ar, he } from 'date-fns/locale';

import { useLanguagesStore } from './languages';
import { useTimezonesStore } from './timezones';
import { useCustomerStore } from './customer';
import moment from 'moment';

moment.defineLocale('kmr', {
	months: 'Rêbandan_Reşemî_Adar_Nîsan_Gulan_Hezîran_Tîrmeh_Tebax_Îlon_Cotmeh_Mijdar_Kanûn'.split('_'),
	monthsShort: 'Rêb_Reş_Ada_Nîs_Gul_Hez_Tîr_Teb_Îlo_Cot_Mij_Kan'.split('_'),
	weekdays: 'Yekşem_Duşem_Sêşem_Çarşem_Pêncşem_În_Şemî'.split('_'),
	weekdaysShort: 'Yek_Duş_Sêş_Çar_Pên_În_Şem'.split('_'),
	weekdaysMin: 'Yk_Dş_Sş_Çr_Pş_În_Şm'.split('_'),
	longDateFormat: {
		LT: 'HH:mm',
		LTS: 'HH:mm:ss',
		L: 'DD/MM/YYYY',
		LL: 'D MMMM YYYY',
		LLL: 'D MMMM YYYY HH:mm',
		LLLL: 'dddd, D MMMM YYYY HH:mm'
	},
	calendar: {
		sameDay: '[Îro di demjimêr] LT [de]',
		nextDay: '[Sibê di demjimêr] LT [de]',
		nextWeek: 'dddd [di demjimêr] LT [de]',
		lastDay: '[Duh di demjimêr] LT [de]',
		lastWeek: 'dddd[a çûyî di demjimêr] LT [de]',
		sameElse: 'L'
	},
	relativeTime: {
		future: 'di %s de',
		past: 'berî %s',
		s: 'çend çirke',
		ss: '%d çirke',
		m: 'xulekek',
		mm: '%d xulek',
		h: 'saatek',
		hh: '%d saat',
		d: 'rojek',
		dd: '%d roj',
		M: 'mehek',
		MM: '%d meh',
		y: 'salek',
		yy: '%d sal'
	},
	ordinal: '%d.',
	week: {
		dow: 1,
		doy: 4
	}
});

const kmrMonths = [
	'Rêbandan',
	'Reşemî',
	'Adar',
	'Nîsan',
	'Gulan',
	'Hezîran',
	'Tîrmeh',
	'Tebax',
	'Îlon',
	'Cotmeh',
	'Mijdar',
	'Kanûn'
];

const kmrDays = [
	'Yekşem',
	'Duşem',
	'Sêşem',
	'Çarşem',
	'Pêncşem',
	'În',
	'Şemî'
];

const kmrDateFns = {
	...enUS,
	code: 'kmr',
	localize: {
		...enUS.localize,
		month: (index) => kmrMonths[index],
		day: (index) => kmrDays[index]
	},
	options: {
		weekStartsOn: 1,
		firstWeekContainsDate: 1
	}
};

export const useDatesStore = defineStore('dates', {
	state: () => ({
		//
	}),
	getters: {
		translateAndOffsetDatetime: () => (datetime, force = false) => {

			const languagesStore = useLanguagesStore();
			const timezonesStore = useTimezonesStore();
			const customerStore = useCustomerStore();

			let locale = 'en';
			locale = languagesStore.selectedLanguage.locale;
			if (locale == 'gr') locale = 'el';

			moment.locale('en');
			let utc_datetime = moment(datetime).utcOffset(0, force);
			let utc_offset = timezonesStore.selectedTimezone.utc_offset;


			if (!customerStore.isLoggedIn) {
				utc_offset = moment().format('Z');
			}

			let offset_datetime = utc_datetime.utcOffset(utc_offset);

			return offset_datetime.locale(locale);
		},
		preFixtureDate: (state) => (datetime, force = false) => {
			return state.translateAndOffsetDatetime(datetime, force).format('DD/MM HH:mm' );
		},
		competitionFixtureDate: (state) => (datetime, force = false) => {
			return state.translateAndOffsetDatetime(datetime, force).format('dddd DD/MM/YY');
		},
		preFixtureBookDate: (state) => (datetime, force = false) => {
			return state.translateAndOffsetDatetime(datetime, force).format('DD/MM');
		},
		preFixtureBookTime: (state) => (datetime, force = false) => {
			return state.translateAndOffsetDatetime(datetime, force).format('HH:mm');
		},
		historyDate: (state) => (datetime, force = false) => {
			return state.translateAndOffsetDatetime(datetime, force).format('DD/MM/YYYY' );
		},
		historyTime: (state) => (datetime, force = false) => {
			return state.translateAndOffsetDatetime(datetime, force).format('HH:mm:ss' );
		},
		accountBonusDate: (state) => (datetime, force = false) => {
			return state.translateAndOffsetDatetime(datetime, force).format('DD/MM/YY HH:mm');
		},
		defaultDate: (state) => (datetime, force = false) => {
			return state.translateAndOffsetDatetime(datetime, force).format('DD/MM/YY HH:mm');
		},
		documentDate: (state) => (datetime, force = false) => {
			return state.translateAndOffsetDatetime(datetime, force).format('YYYY-MM-DD HH:mm:ss');
		},
		fixtureSearchDate: (state) => (datetime, force = false) => {
			return state.translateAndOffsetDatetime(datetime, force).format('dddd DD/MM/YY HH:mm');
		},
		messageDate: (state) => (datetime, force = false) => {
			if (state.translateAndOffsetDatetime(datetime, force).isSame(moment(), 'day')) {
				return 'Today, ' + state.translateAndOffsetDatetime(datetime, force).format('HH:mm');
			}else {
				return state.translateAndOffsetDatetime(datetime, force).format('dddd D MMMM, YYYY');
			}
		},
		messageDocumentDate:(state) => (datetime, force = false) => {
			return state.translateAndOffsetDatetime(datetime, force).format('DD MMM, YYYY');
		},
		year:(state) => (datetime, force = false) => {
			return state.translateAndOffsetDatetime(datetime, force).format('YYYY');
		},
		messagesDate: (state) => (datetime, force = false) => {
			if (state.translateAndOffsetDatetime(datetime, force).isSame(moment(), 'day')) {
				return state.translateAndOffsetDatetime(datetime, force).format('HH:mm A');
			}else {
				return state.translateAndOffsetDatetime(datetime, force).format('DD/MM HH:mm A' );
			}
		},
		defaultPeriod: () => () => {
			const now = moment().locale('en');
			const start = now.clone().startOf('month');
			return {
				from: start.format('YYYY-MM-DD'),
				to: now.format('YYYY-MM-DD'),
			};
		},
		apiDateFromParts: () => (year, monthIndex, day) => {
			return moment.utc([year, monthIndex, day]).locale('en').format('YYYY-MM-DD');
		},
		datepickerLocale: () => (t) => {
			const languagesStore = useLanguagesStore();

			let locale = enUS;

			if (languagesStore.selectedLanguage.locale == 'fa') {
				const persian_months = [
					t('general.january'),
					t('general.february'),
					t('general.march'),
					t('general.april'),
					t('general.may'),
					t('general.june'),
					t('general.july'),
					t('general.august'),
					t('general.september'),
					t('general.october'),
					t('general.november'),
					t('general.december'),
				];

				locale = {
					...faIR,
					localize: {
						...faIR.localize,
						month: (index) => persian_months[index]
					}
				};
			}

			else if (languagesStore.selectedLanguage.locale == 'gr') locale = el;
			else if (languagesStore.selectedLanguage.locale == 'de') locale = de;
			else if (languagesStore.selectedLanguage.locale == 'fr') locale = fr;
			else if (languagesStore.selectedLanguage.locale == 'sr') locale = sr;
			else if (languagesStore.selectedLanguage.locale == 'tr') locale = tr;
			else if (languagesStore.selectedLanguage.locale == 'es') locale = es;
			else if (languagesStore.selectedLanguage.locale == 'pt') locale = pt;
			else if (languagesStore.selectedLanguage.locale == 'it') locale = it;
			else if (languagesStore.selectedLanguage.locale == 'ru') locale = ru;
			else if (languagesStore.selectedLanguage.locale == 'ar') locale = ar;
			else if (languagesStore.selectedLanguage.locale == 'kmr') locale = kmrDateFns;
			else if (languagesStore.selectedLanguage.locale == 'he') locale = he;

			return locale;
		},
	},
	actions: {
	},
})